import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import SimpleAppBar from "@/fragments/SimpleAppBar";

export default function Refund() {
  const navigate = useNavigate();
  return (
    <Box>
      <SimpleAppBar />

      <Box sx={{ p: 2 }}>
        <Typography variant="h6" style={{ fontWeight: 800 }} sx={{ mb: 2 }}>
          Refund Policy
        </Typography>
        <Typography>
          Notebook does not offer refunds, all purchases are final. You may
          cancel your subscription at any time by emailing support@notebook.fm.
        </Typography>
      </Box>
    </Box>
  );
}
